module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.ttf?cdb643e4a7e53d04b7b9f3d1cc987f7d";